import axios from 'axios';

const api = axios.create({
  //baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
});

// The token this TAB is authenticated with.
//
// Deliberately NOT read from localStorage per request: localStorage is shared by
// every tab on the origin, so a second tab logging in as another user used to
// silently redirect this tab's requests to that user's identity while the UI
// still rendered the old one. Holding it in memory means a tab can only ever act
// as the user it booted (or logged in) as. AuthContext owns this value.
//
//   undefined = not initialised yet (fall back to localStorage)
//   null      = explicitly signed out
let activeToken: string | null | undefined = undefined;

export const setActiveToken = (token: string | null) => {
  activeToken = token;
};

// Auto-inject auth token on every request
api.interceptors.request.use((config) => {
  const token = activeToken !== undefined ? activeToken : localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;